import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import SearchField from "../Shared/SearchField";
import BouncedContactsList from "./BouncedContactsList";
import ContactsByFilterComponent from "./ContactsByFilterComponent";
import ContactsTabOption from "./ContactsTabOption";
import DeliveredContactsList from "./DeliveredContactsList";
import UnsubscribedContactsList from "./UnsubscribedContactsList";
import store, { RootState } from "../../../store";
import {
  PATH_ANALYTICS,
  TAB_ANALYTICS,
  TAB_CONTACTS_ANALYTICS,
  TAB_ANALYTICS_INNER,
} from "../../../constants/paths";
import { getBouncedContactsList, getDeliveredContactsList, getUnsubscribedContactsList, setBounceFilter, setBounceFilterFirstTime } from "./action";
import ContactsDashboard from "./ContactsInner/Dashboard/ContactsDashboard";
import ContactsContent from "./ContactsInner/ContentEngagement/ContactsContent";
import { ANALYTICS_FILTERS, CONTACT_ANALYTICS } from "constants/types";
import {
  resetAllContactProps,
  resetContactSearch,
  resetAllTabsFilter,
  getConstantCampaignEmailId,
} from "../utils";
import { getAnalyticsFilterId, getQueryCampaignId, getQueryEmailId, getQueryEmailIds, getQueryIsAIEmail, getQueryWorkflowId } from "modules/EmailBrowser/utils";
import { addCommaToNumber, getQuarterDates, getQueryAccountId, removeCampaignAndEmailQueryParams } from "utils";
import { analyticsDatesFilterChange, selectAsset } from "../Dashboard/actions";
import ExportAnalyticsPopup from "../Shared/ExportAnalyticsPopup";
import { ANALYTICS_DEFAULT_DATES_FILTER } from "./utils";
import { moveSelectedFiltersToApplied } from "../actions";
import BounceTypeFilterComponent from "./BounceTypeFilterComponent";

interface IContactsWrapper {
  page?: string;
  tab?: string;
  setSearchedText: (value: string) => void;
  searchedText: string;
}
const ContactsWrapper: FC<IContactsWrapper> = (props: IContactsWrapper) => {
  //Props Contants
  const { tab, page, searchedText, setSearchedText } = props;

  //Local States
  // const [tabSwitch, setTabSwitch] = useState(false);
  const [firstRender, setFirstRender] = useState(true);

  //Redux States
  const filterReset = useSelector((state: RootState) => state.contactAnalytics.filterReset);
  const searchReset = useSelector((state: RootState) => state.contactAnalytics.searchReset);
  const total_delivered = useSelector((state: RootState) => state.contactAnalytics.total_delivered);
  const total_bounced = useSelector((state: RootState) => state.contactAnalytics.total_bounced);
  const total_unsubscribed = useSelector((state: RootState) => state.contactAnalytics.total_unsubscribed);
  const deliveredPage = useSelector((state: RootState) => state.contactAnalytics.deliveredPage);
  const bouncedPage = useSelector((state: RootState) => state.contactAnalytics.bouncedPage);
  const unsubscribedPage = useSelector((state: RootState) => state.contactAnalytics.unsubscribedPage);

  const selectedCampaignIds = useSelector((state: RootState) => state.analyticsDashboard.selectedCampaignsIds);
  const contactsByFilter = useSelector((state: RootState) => state.contactAnalytics.contactsByFilter);
  const isFilterClicked = useSelector((state: RootState) => state.analyticsFilters.filterApplied);
  const AllCampaignsFilterCheck = useSelector(
    (state: RootState) => state.analyticsDashboard.appliedCampaignsFilters.isAllCampaigns
  );
  const { isShareProfile, isDailyIQ, isWeeklyAccountInsights } = useSelector(
    (state: RootState) => state.analyticsDashboard.appliedCampaignsFilters
  );

  const [accountId, setAccountId] = useState(0);

  const tabArray = [
    {
      pillName: `Delivered ${deliveredPage !== 0 ? "(" + addCommaToNumber((total_delivered ?? 0).toString() ?? "") + ")" : ""}`,
      to:
        window.location.search.length > 0
          ? `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTACTS}/${TAB_CONTACTS_ANALYTICS.DELIVERED}/${window.location.search}`
          : `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTACTS}/${TAB_CONTACTS_ANALYTICS.DELIVERED}`,
      isActive: tab === undefined || tab === TAB_CONTACTS_ANALYTICS.DELIVERED,
      onClick: () => {
        // setTabSwitch(true);
      },
      idBtn: "delivered-tab",
    },
    {
      pillName: `Bounced ${bouncedPage !== 0 ? "(" + addCommaToNumber((total_bounced ?? 0).toString() ?? "") + ")" : ""}`,
      to:
        window.location.search.length > 0
          ? `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTACTS}/${TAB_CONTACTS_ANALYTICS.BOUNCED}/${window.location.search}`
          : `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTACTS}/${TAB_CONTACTS_ANALYTICS.BOUNCED}`,
      isActive: tab === TAB_CONTACTS_ANALYTICS.BOUNCED,
      onClick: () => {
        // setTabSwitch(true);
      },
      idBtn: "bounced-tab",
    },
    {
      pillName: `Unsubscribed ${unsubscribedPage !== 0 ? "(" + addCommaToNumber((total_unsubscribed ?? 0).toString() ?? "") + ")" : ""}`,
      to:
        window.location.search.length > 0
          ? `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTACTS}/${TAB_CONTACTS_ANALYTICS.UNSUBSCRIBED}/${window.location.search}`
          : `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTACTS}/${TAB_CONTACTS_ANALYTICS.UNSUBSCRIBED}`,
      isActive: tab === TAB_CONTACTS_ANALYTICS.UNSUBSCRIBED,
      onClick: () => {
        // setTabSwitch(true);
      },
      idBtn: "unsubscribed-tab",
    },
  ];
  const getParams = (tabValue?: string, resetsearch?: boolean, isAccount?: boolean) => {
    let analyticsDashboard = store.getState().analyticsDashboard;
    let analyticsGraph = store.getState().analyticsGraph;
    let bounceFilter = store.getState().contactAnalytics.bounceFilter;
    let { appliedCampaignIds, appliedAssetsIds, appliedWorkflowsIds, excludeCampaignsIds, excludeAssetsIds } = analyticsDashboard;
    let { startDate, endDate } = analyticsGraph;

    let campaignIds;
    let emailIds;
    let workflowIds;
    let fsId = getAnalyticsFilterId();

    if (filterReset === true || (searchReset === true && firstRender === false)) {
      campaignIds = appliedCampaignIds;
      emailIds = appliedAssetsIds;
      workflowIds = appliedWorkflowsIds;
    } else {
      if (!fsId && firstRender) {
        const queryCampaignId = getQueryCampaignId();
        const isAIEmail = getQueryIsAIEmail();
        if (selectedCampaignIds.length <= 0 && queryCampaignId > 0 && firstRender === true) {
          campaignIds = selectedCampaignIds.length > 0 ? selectedCampaignIds : [queryCampaignId];
          if (isAIEmail) {
            const emailIds = getQueryEmailIds();
            emailIds.forEach((id: number) => {
              selectAsset(id, queryCampaignId)
            })
          }
          else {
            selectAsset(getQueryEmailId(), queryCampaignId);
          }
          moveSelectedFiltersToApplied();
        } else campaignIds = appliedCampaignIds;
        if (appliedAssetsIds.length <= 0 && getQueryEmailId() > 0 && firstRender === true) {
          if (isAIEmail) {
            emailIds = appliedAssetsIds.length > 0 ? appliedAssetsIds : getQueryEmailIds()
          }
          else {
            emailIds = appliedAssetsIds.length > 0 ? appliedAssetsIds : [getQueryEmailId()];
          }
        } else emailIds = appliedAssetsIds;
        if (appliedWorkflowsIds.length <= 0 && getQueryWorkflowId() > 0 && firstRender === true) {
          workflowIds = appliedWorkflowsIds.length > 0 ? appliedWorkflowsIds : [getQueryWorkflowId()];
        } else workflowIds = appliedWorkflowsIds;
      }
      else {
        campaignIds = appliedCampaignIds;
        emailIds = appliedAssetsIds;
        workflowIds = appliedWorkflowsIds;
      }
    }

    if (startDate === "" && endDate === "") {
      analyticsDatesFilterChange(ANALYTICS_DEFAULT_DATES_FILTER);
      startDate = getQuarterDates().start_date;
      endDate = getQuarterDates().end_date;
    }

    // check if is share profile || daily IQ || weekly accounts insights
    if (isShareProfile || isDailyIQ || isWeeklyAccountInsights) {
      let campaign_email_id = getConstantCampaignEmailId({ isShareProfile, isDailyIQ, isWeeklyAccountInsights });
      campaignIds = [campaign_email_id];
      emailIds = [campaign_email_id];
    }

    let _params: any = {
      allCampaigns: AllCampaignsFilterCheck,
      limit: 20,
      tab: tabValue ?? tab,
      searchWord: resetsearch === true ? "" : searchedText,
      offset: 0,
      emailIds: emailIds,
      workflowIds,
      startDate: startDate,
      endDate: endDate,
      campaignIds: campaignIds,
    };
    if (AllCampaignsFilterCheck) {
      _params["excludeCampaignsIds"] = excludeCampaignsIds;
      _params["excludeAssetsIds"] = excludeAssetsIds;
    }
    if (isAccount) {
      _params["accountId"] = getQueryAccountId();
    } else {
      if (getQueryAccountId() !== undefined) _params["accountId"] = getQueryAccountId();
    }
    if (contactsByFilter) _params["contactsByFilter"] = contactsByFilter;
    if (tabValue === "bounced" && bounceFilter !== "") _params['bounce_filter'] = bounceFilter;
    return _params;
  };

  const fetchAllContactsForTab = (tab?: string, resetSearch?: boolean, isAccount?: boolean, searchedText?: string, isFilterClicked?: boolean) => {
    let reFetchFlag = searchedText || resetSearch || isFilterClicked;
    getDeliveredContactsList(getParams("delivered", resetSearch, isAccount));
    getBouncedContactsList(getParams("bounced", resetSearch, isAccount));
    getUnsubscribedContactsList(getParams("unsubscribed", resetSearch, isAccount));
    setTimeout(() => {
      store.dispatch({
        type: CONTACT_ANALYTICS.FILTER_RESET,
        payload: false,
      });
      store.dispatch({ type: CONTACT_ANALYTICS.SEARCH_RESET, payload: searchedText !== "" ? true : false });
    }, 500);
  };

  useEffect(() => {
    return () => {
      setBounceFilter("");
      setBounceFilterFirstTime(false);
    }
  }, [])

  useEffect(() => {
    if (firstRender === false) {
      resetAllContactProps();
      fetchAllContactsForTab(tab, false, accountId > 0, searchedText);
      resetContactSearch();
    }
  }, [searchedText]);

  useEffect(() => {
    if (isFilterClicked === true) {
      store.dispatch({
        type: CONTACT_ANALYTICS.BOUNCED_RESET,
      });
      store.dispatch({ type: ANALYTICS_FILTERS.RESET });
      resetAllTabsFilter(true);
      resetAllContactProps();
      fetchAllContactsForTab(tab, false, accountId > 0, searchedText, true);
    }
  }, [isFilterClicked]);

  useEffect(() => {
    let queryAccountId = getQueryAccountId();
    // if (tab === TAB_CONTACTS_ANALYTICS.DELIVERED) {
    //   fetchAllContactsForTab(tab, searchedText === "", accountId > 0);
    // } else if (tab === TAB_CONTACTS_ANALYTICS.BOUNCED) {
    //   fetchAllContactsForTab(tab, searchedText === "", accountId > 0);
    // } else if (tab === TAB_CONTACTS_ANALYTICS.UNSUBSCRIBED) {
    //   fetchAllContactsForTab(tab, searchedText === "", accountId > 0);
    // }
    fetchAllContactsForTab(tab, searchedText === "", accountId > 0, searchedText);

    if (queryAccountId !== accountId) {
      setAccountId(queryAccountId);
    }
  }, [])

  useEffect(() => {
    // if (
    //   (delivered.length <= 0 && !deliveredLoading && tab !== "content" && tab !== "dashboard") ||
    //   searchReset === true ||
    //   filterReset === true
    // ) {
    //   fetchAllContacts(true, getQueryAccountId() > 0);
    //   if (getQueryAccountId()) {
    //     setAccountId(getQueryAccountId());
    //   }
    // } else if (delivered.length > 0 && !deliveredLoading && getQueryAccountId()) {
    //   fetchAllContacts(true, getQueryAccountId() > 0);
    //   setAccountId(getQueryAccountId());
    // }
    setSearchedText("");
    setFirstRender(false);
    return () => {
      resetAllContactProps();
    };
  }, []);

  return (
    <Wrapper className="contacts-deliverd">
      <div>
        {page === TAB_ANALYTICS.CONTACTS &&
          tab !== TAB_ANALYTICS_INNER.DASHBOARD &&
          tab !== TAB_ANALYTICS_INNER.CONTENT && (
            <div className="search-field-container">
              <ContactsTabOption tabArray={tabArray} />
              <div className="d-flex">
                <div className="scaled-width-36 me-2 pe-1">
                  {(tab === undefined || tab === TAB_CONTACTS_ANALYTICS.DELIVERED) && (
                    <ContactsByFilterComponent searchedText={searchedText} />
                  )}
                  {(tab === undefined || tab === TAB_CONTACTS_ANALYTICS.BOUNCED) && (
                    <BounceTypeFilterComponent searchedText={searchedText} />
                  )}
                </div>
                <div className="scaled-width-35">
                  <SearchField
                    placeholder="Search Contacts..."
                    handleSearch={(value: string) => {
                      setSearchedText(value);
                      if (value === "") {
                        fetchAllContactsForTab(tab, true, accountId > 0);
                      }
                    }}
                    reset={searchedText}
                  />
                </div>
              </div>
            </div>
          )}
        {tab === undefined || tab === TAB_CONTACTS_ANALYTICS.DELIVERED ? (
          <DeliveredContactsList tab={tab} searchedText={searchedText} setSearchedText={setSearchedText} />
        ) : tab === TAB_CONTACTS_ANALYTICS.BOUNCED ? (
          <BouncedContactsList tab={tab} searchedText={searchedText} setSearchedText={setSearchedText} />
        ) : tab === TAB_CONTACTS_ANALYTICS.UNSUBSCRIBED ? (
          <UnsubscribedContactsList tab={tab} searchedText={searchedText} setSearchedText={setSearchedText} />
        ) : tab === TAB_ANALYTICS_INNER.DASHBOARD ? (
          <ContactsDashboard tab={tab} />
        ) : tab === TAB_ANALYTICS.CONTENT ? (
          <ContactsContent tab={tab} />
        ) : null}
        <ExportAnalyticsPopup page={"contacts"} searchedText={searchedText} />
      </div>
    </Wrapper>
  );
};

export default ContactsWrapper;

const Wrapper = styled.div`
  .search-field-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 5px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-top: 7px;
    }
    button .wrapper {
      white-space: nowrap;
    }
  }
  .total-count {
    color: #7e7e7e;
    font-size: 14px;
    font-weight: 500;
    font-family: "Roboto", sans-serif;
  }
  .scaled-width-35 {
    width: 200px;
  }
  .scaled-width-36 {
    width: 280px;
  }
`;
